var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_7539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 12,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96967 1.46967C1.26256 1.17678 1.73744 1.17678 2.03033 1.46967L11.0303 10.4697C11.3232 10.7626 11.3232 11.2374 11.0303 11.5303C10.7374 11.8232 10.2626 11.8232 9.96967 11.5303L0.96967 2.53033C0.676777 2.23744 0.676777 1.76256 0.96967 1.46967Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0303 1.46967C10.7374 1.17678 10.2626 1.17678 9.96967 1.46967L0.96967 10.4697C0.676777 10.7626 0.676777 11.2374 0.96967 11.5303C1.26256 11.8232 1.73744 11.8232 2.03033 11.5303L11.0303 2.53033C11.3232 2.23744 11.3232 1.76256 11.0303 1.46967Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_7539)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bb04d9256f305e4ea9ca3b6d1f484e48.svg";
export { ForwardRef as ReactComponent };